import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import type { PropsWithChildren } from "react";

export const Portal = ({ children }: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  return mounted
    ? createPortal(
        children,
        document.querySelector("#cohort-switch-portal") as Element,
      )
    : null;
};
